import type { Finding } from "../contracts/types";

interface FindingsListProps {
  findings: Finding[];
}

export function FindingsList({ findings }: FindingsListProps) {
  if (findings.length === 0) {
    return <p className="field-hint">Sin hallazgos de nivel de ejecución para este escenario.</p>;
  }
  return (
    <ul className="findings-list">
      {findings.map((finding, index) => (
        <li key={`${finding.ruleId}-${index}`} className={`severity-${finding.severity}`}>
          <strong>{finding.ruleId}</strong> — {finding.message}
          {finding.evidencePath ? (
            <>
              {" "}
              <code>{finding.evidencePath}</code>
            </>
          ) : null}
          {finding.suggestion ? <p className="field-hint">{finding.suggestion}</p> : null}
        </li>
      ))}
    </ul>
  );
}
